<div style="padding-top: 10px; margin: 40px">
    <div class="registered-row" style="margin-bottom: 20px;">
        <h2 class="title">Setores Cadastrados</h2>
        <button (click)="cleanForm(true)" style="float: right;" mat-raised-button class="mt-3 new-panel-btn">
            Novo Setor
            <mat-icon>add_circle</mat-icon>
        </button>
    </div>
    <div rowHeight=500px class="setores-row"> 
        <div class="card table-side">
            <table mat-table [dataSource]="setores" class="demo-table">
                <ng-container matColumnDef="descricao" sticky>
                    <th mat-header-cell *matHeaderCellDef> Descrição </th>
                    <td style="width: 60%" mat-cell *matCellDef="let element"> {{element.descricao}} </td>
                </ng-container>
                <ng-container matColumnDef="prefixo">
                    <th mat-header-cell *matHeaderCellDef> Prefixo </th>
                    <td style="width: 10%" mat-cell *matCellDef="let element"> {{element.prefixo}} </td>
                </ng-container>
                <ng-container matColumnDef="botao">
                    <th mat-header-cell *matHeaderCellDef> Botão </th>
                    <td style="width: 8%" mat-cell *matCellDef="let element"> {{formatBotao(element.botao)}} </td>
                </ng-container>
                <ng-container matColumnDef="cor">
                    <th mat-header-cell *matHeaderCellDef> Cor </th>
                    <td style="width: 5%" mat-cell *matCellDef="let element"> <div class="color-grid-box" [ngStyle]="{'background-color': element.cor }"></div> </td>
                </ng-container>
                <ng-container matColumnDef="corfonte">
                    <th mat-header-cell *matHeaderCellDef> Fonte </th>
                    <td style="width: 5%" mat-cell *matCellDef="let element"> <div class="color-grid-box" [ngStyle]="{'background-color': element.corfonte }"></div> </td>
                </ng-container>
                <ng-container matColumnDef="is_agendamentos">
                    <th mat-header-cell *matHeaderCellDef> Agendamentos </th>
                    <td style="width: 10%" mat-cell *matCellDef="let element"> {{formatBotao(element.is_agendamentos)}} </td>
                </ng-container>
                <ng-container matColumnDef="ordem">
                    <th mat-header-cell *matHeaderCellDef> Ordem </th>
                    <td style="width: 5%" mat-cell *matCellDef="let element"> {{element.ordem || 0}} </td>
                </ng-container>
                <ng-container matColumnDef="edit" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td style="width: 5%" mat-cell *matCellDef="let element; let i = index">
                        <button (click)="setSetor(i)" style="margin:10px" mat-raised-button class="purple-btn">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button [disabled]="showSpinner ? true : false" (click)="deleteSetor(element.id)" style="margin:10px"
                            mat-raised-button class="gray-btn" color="accent">
                            <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                            </mat-spinner>
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <div class="form-side-modal" *ngIf="isModalOpen">
            <div class="card form-side">
                <h3 class="setting-title">{{ setor.descricao || 'Adicionar Setor'}}</h3>
                <form [formGroup]="formSetor" (submit)="submitForm()" method="post">
                    <div class="form-inputs-col">
                        <mat-form-field required style="margin: 10px">
                            <mat-label>Descrição</mat-label>
                            <input type="text" formControlName=descricao matInput>
                            <mat-error *ngIf="formSetor.get('descricao')?.hasError('required')">
                                A descrição é obrigatória
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field style="margin: 10px">
                            <mat-label>Prefixo</mat-label>
                            <input type="text" formControlName=prefixo matInput>
                            <mat-error *ngIf="formSetor.get('prefixo')?.hasError('maxlength')">
                                O prefixo deve ter no máximo 3 caracteres
                                (atual: {{ formSetor.get('prefixo')?.errors?.maxlength?.actualLength }})
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field style="margin: 10px">
                            <mat-label>Botão</mat-label>
                            <mat-select required name="botao" style="height: 10px !important;" formControlName="botao">
                                <mat-option value=true>Sim</mat-option>
                            <mat-option value=false>Não</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div fxLayout="row">
                    <mat-form-field  class="color-field" style="margin: 10px;">
                        <div style="display: flex; align-items: center;">
                            <input class="color-input" type="color" formControlName=cor matInput>
                            <span>{{formSetor.get('cor')?.value}}</span>
                        </div>
                        <mat-label>Cor de fundo</mat-label>
                    </mat-form-field>
                    <mat-form-field class="color-field" style="margin: 10px;">
                        <div style="display: flex; align-items: center;">
                            <input class="color-input" type="color" formControlName=corfonte matInput>
                            <span>{{formSetor.get('corfonte')?.value}}</span>
                        </div>
                        <mat-label>Cor da fonte</mat-label>
                    </mat-form-field>
                </div>
                <mat-form-field style="margin: 10px; width: 80px;">
                    <mat-label>Ordem</mat-label>
                    <input type="number" formControlName=ordem matInput>
                </mat-form-field>
                <mat-form-field style="margin: 10px">
                    <mat-label>Localizar agendamentos?</mat-label>
                    <mat-select required name="is_agendamentos" style="height: 10px !important;" formControlName="is_agendamentos">
                        <mat-option value=true>Sim</mat-option>
                        <mat-option value=false>Não</mat-option>
                        <mat-option value=direct>Direto</mat-option>
                    </mat-select>
                </mat-form-field>
                </div>
                <div class="form-buttons-row">
                    <button (click)="cleanForm()" [disabled]="showSpinner ? true : false" class="mt-3 reset-btn" mat-raised-button>
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                        </mat-spinner> Cancelar
                    </button>
                    <button [disabled]="showSpinner ? true : false" class="mt-3" mat-raised-button
                        color="primary" type="submit">
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                        </mat-spinner> {{buttonText}}
                    </button>
                </div>
            </form>
        </div>
        </div>
    </div>
</div>